





































































































































































import {
	computed,
	defineComponent,
	PropType,
	ref,
	Ref,
	watch,
} from '@vue/composition-api';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { useIntersectionObserver } from '@vueuse/core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import ShareContentModal from '@front-app/components/share/ShareContentModal.vue';
import { Routes } from '@front-app/constants/routes';
import {
	hasAdminPrivileges,
	areDiscussionsVisibleForCurrentUser,
	areDiscussionsStartableForCurrentUser,
	isStartDiscussionCtaVisibleForCurrentUser,
	canSeeJoinLink,
	// useUserMustAcceptGroupTerms,
	canShareFilesToGroup,
	canManageDocumentCategories,
	canViewGroupEvents,
	canViewMainTab,
	canViewContentTab,
	canViewCustomTab,
	// showLimitedAccessMessage,
	canViewLmsTab,
	hasGroupAccess,
	// showProfessionalRoleRequiredPage,
} from '@front-app/util/permission';
import { trackGroupSimpleAction } from '@front-app/services/ActionApi/ActionApi';
import { GroupAuditAction } from '@front-app/services/ActionApi/ActionModel';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { useIsLoading } from '@front-app/hooks/useAsyncStatus';
import { Size } from '@front-app/components/constants';
import { ContentQueryParam } from '@front-app/modules/content/routing/params';
import TabbedNav from '@front-app/components/tabs/TabbedNav.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import GroupDetails from '@front-app/components/group/GroupDetails.vue';
import { useGroupMembersStore } from '@front-app/store/singletons/GroupMembers';
import { useDiscussionModal } from '@front-app/components/discussion/useDiscussionModal';
import JoinButton from '@front-app/components/buttons/concrete/JoinButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { useGroupMemberStateChange } from '@front-app/modules/group/hooks/useGroupMemberStateChange';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { GroupRoleRequest } from '@front-app/services/GroupsApi/GroupsMemberApi';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import TermsCard from '@front-app/components/cards/TermsCard.vue';
import PlusButton from '@front-app/components/buttons/PlusButton.vue';
import { useCommunityColors } from '@front-app/modules/community/hooks/useCommunityColors';
import ContactUsLink from '@front-app/components/ContactUsLink.vue';
import GroupPageColumnError from '@front-app/modules/group/components/layouts/GroupPageColumnError.vue';
import GroupPageColumnLoading from '@front-app/modules/group/components/layouts/GroupPageColumnLoading.vue';
import GroupPageColumnInvitedWrongUser from '@front-app/modules/group/components/layouts/GroupPageColumnInvitedWrongUser.vue';
import NavBar from '@front-app/modules/group/components/memberArea/NavBar.vue';
import { ShareContentPanelState } from '@front-app/modules/group/util/shareContentModal';
import WarningCard from '@front-app/components/cards/state/WarningCard.vue';
import EditContentModal from '@front-app/modules/group/components/memberArea/EditContentModal.vue';
import { ContentType } from '@front-app/services/GroupsApi/DiscussionModel';
import { getGroupContentV2 } from '@front-app/services/GroupsApi/GroupsContentApi';
import { useGroupContentStore } from '@front-app/store/piniaModules/groupContent';
import { syncedRef } from '@front-app/util/reactivity';
import { compareTrimmedStringCharacters } from '@front-app/util/string';
import { isGroupContentVisible } from '@front-app/modules/group/util/visibility';
import GroupGatingModal from '@front-app/modules/group/components/memberArea/GroupGatingModal.vue';
import GroupHeader from './group/GroupHeader.vue';
import { GroupPageTab } from './groups/GroupEnum';

const GROUP_TAB_BUTTONS = [
	GroupPageTab.MAIN,
	GroupPageTab.CONTENT,
	GroupPageTab.EVENTS,
	GroupPageTab.CUSTOM,
	GroupPageTab.LMS,
];

const SHOW_TABS_ROUTES: unknown[] = [
	Routes.GROUP,
	Routes.GROUP_MAIN,
	Routes.GROUP_CONTENT,
	Routes.GROUP_EVENTS,
	Routes.GROUP_CUSTOM,
	Routes.GROUP_MEMBERS,
	Routes.GROUP_LEARNING,
	Routes.GROUP_LEARNING_PROGRAMS_LIST,
	Routes.GROUP_LEARNING_PROGRAM,
	Routes.GROUP_LEARNING_MODULE,
];

const FALLBACK_ROUTE: Record<GroupPageTab, Routes> = {
	[GroupPageTab.MAIN]: Routes.GROUP_CONTENT,
	[GroupPageTab.CONTENT]: Routes.GROUP_EVENTS,
	[GroupPageTab.EVENTS]: Routes.GROUP_CUSTOM,
	[GroupPageTab.CUSTOM]: Routes.GROUP_LEARNING,
	[GroupPageTab.LMS]: Routes.GROUP_MAIN,
};

const EDIT_CONTENT_PANEL_BY_TYPE = {
	[ContentType.FILE]: EditContentModal,
	[ContentType.LINK]: EditContentModal,
};

export default defineComponent({
	components: {
		ColumnContainer,
		LoaderState,
		GroupHeader,
		TabbedNav,
		PaddedContent,
		ShareContentModal,
		SlidingPanel,
		GroupDetails,
		CtaButton,
		FontAwesomeIcon,
		JoinButton,
		SimpleCard,
		TermsCard,
		ContactUsLink,
		GroupPageColumnError,
		GroupPageColumnLoading,
		GroupPageColumnInvitedWrongUser,
		NavBar,
		WarningCard,
		PlusButton,
		GroupGatingModal,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		email: {
			type: String,
			default: '',
		},
		inviteId: {
			type: String,
			default: '',
		},
		shareContentPanelState: {
			type: String as PropType<ShareContentPanelState>,
			default: ShareContentPanelState.CLOSED,
		},
		shareToDiscussionId: {
			type: String,
			default: '',
		},
		contentIdToEdit: {
			type: String,
			default: '',
		},
		startDiscussion: Boolean,
	},
	setup(props, ctx) {
		const { currentUser, isCsr, isLoggedIn } = CurrentUserStore;

		// Invites
		const invalidInviteEmail = computed(() => Boolean(props.inviteId)
			&& Boolean(props.email)
			&& !compareTrimmedStringCharacters(currentUser.value.email, props.email));
		// END Invites

		// Group setup
		watch(() => props.groupId, (curr: string) => {
			GroupsStore.getInstance().fetchGroup(curr, true);
		}, { immediate: true });
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		// Below triggers a fetch automatically
		const { status: memberFetchStatus, getAdministrators } = useGroupMembersStore(computed(() => props.groupId));
		const isLoadingMembers = useIsLoading(memberFetchStatus);
		// END Group setup

		// Routing
		const showNavbar = computed(() => SHOW_TABS_ROUTES.includes(ctx.root.$route.name));
		// END Routing

		// Tabbed nav
		const currentTabKey = computed(() => {
			switch (ctx.root.$route.name) {
			case Routes.GROUP_CONTENT:
				return GroupPageTab.CONTENT;
			case Routes.GROUP_EVENTS:
				return GroupPageTab.EVENTS;
			case Routes.GROUP_CUSTOM:
				return GroupPageTab.CUSTOM;
			case Routes.GROUP_LEARNING:
			case Routes.GROUP_LEARNING_PROGRAMS_LIST:
			case Routes.GROUP_LEARNING_PROGRAM:
			case Routes.GROUP_LEARNING_MODULE:
				return GroupPageTab.LMS;
			case Routes.GROUP:
			case Routes.GROUP_MAIN:
				return GroupPageTab.MAIN;
			default:
				// This represents the case where a user is navigating to the group's admin, event, or similar, page
				// where no tab is used at all
				return null;
			}
		});
		const isTabEnabled = (tab: GroupPageTab | null): boolean => {
			switch (tab) {
			case GroupPageTab.MAIN:
				return canViewMainTab(group.value);
			case GroupPageTab.CONTENT:
				return canViewContentTab(group.value);
			case GroupPageTab.EVENTS:
				return canViewGroupEvents(group.value);
			case GroupPageTab.CUSTOM:
				return canViewCustomTab(group.value);
			case GroupPageTab.LMS:
				return canViewLmsTab(group.value);
			case null:
			default:
				return true;
			}
		};
		const visibleTabs: Ref<GroupPageTab[]> = computed(() => GROUP_TAB_BUTTONS.filter(isTabEnabled));
		// END Tabbed nav

		// Loading
		const groupIsLoading = computed(() => GroupsStore.getInstance().isGroupLoading(props.groupId));
		const groupHasError = computed(() => GroupsStore.getInstance().isGroupErrorred(props.groupId));
		// END Loading

		const trackTermsView = (curr: boolean, prev?: boolean) => {
			if (curr && !prev && props.groupId) {
				trackGroupSimpleAction(props.groupId, GroupAuditAction.VIEW_GROUP_TERMS);
			}
		};

		// Group details
		const areDetailsVisible = ref(false);
		const administrators = computed(() => getAdministrators());
		const isTermsPanelVisible = ref(false);
		const isAdministeredGroup = computed(
			() => hasAdminPrivileges(group.value?.role, isCsr.value),
		);
		watch(isTermsPanelVisible, trackTermsView, { immediate: true });
		// END Group details

		// Resize group header on scroll
		// NOTE: the reason that we add extra padding by using a sentinel located below the actual
		// header is because if the page is short, the header will cause a flickering jumpy effect
		// soon as you start scrolling if there's no extra padding. But the extra padding looks weird
		// if you trigger the minification of the header immediately. So it needs to be delayed a bit
		const sentinel = ref(null) as Ref<null | HTMLElement>;
		const isHeaderPinned = ref(false);
		useIntersectionObserver(
			sentinel,
			([{ intersectionRatio }]) => {
				isHeaderPinned.value = intersectionRatio < 1;
			},
			{ threshold: [1], rootMargin: '-70px 0px 0px 0px' },
		);
		// END Resize group header on scroll

		// Edit content panel
		const groupContentStore = useGroupContentStore();
		const selectedContent = syncedRef(() => groupContentStore.getById(groupContentStore.selectedContentId)).ref;

		const closeEditContentModal = () => {
			if (!selectedContent.value) {
				return;
			}

			const q = ctx.root.$route.query;
			ctx.root.$router.push({ query: { ...q, [ContentQueryParam.EDIT_CONTENT]: '' } });
		};

		watch(() => props.contentIdToEdit, async (curr, prev) => {
			if (!curr || curr === prev) {
				return;
			}

			let content = groupContentStore.getById(curr);

			// Fetch content only if it is not yet in the store
			if (!content) {
				content = await getGroupContentV2(props.groupId, curr);
				groupContentStore.update([content]);
			}

			if (content.type !== ContentType.DISCUSSION) {
				groupContentStore.selectContent(content.id);
			}
		}, { immediate: true });
		// END Edit content panel

		// Group Discussion Form Panel
		const areDiscussionsEnabled = computed(() => {
			if (group.value) {
				return areDiscussionsVisibleForCurrentUser(group.value, isCsr.value);
			}
			return false;
		});
		const canStartDiscussions = computed(() => {
			if (group.value) {
				return areDiscussionsStartableForCurrentUser(group.value, isCsr.value);
			}
			return false;
		});
		const canSeeStartDiscussionCta = computed(() => {
			if (group.value) {
				return isStartDiscussionCtaVisibleForCurrentUser(group.value, isCsr.value);
			}
			return false;
		});
		const {
			isDiscussionModalVisible,
			discussionModalView,
			showDiscussionModal: _showDiscussionModal,
			closeDiscussionModal,
		} = useDiscussionModal('groupHeaderStartDiscussionButton');
		const showDiscussionModal = () => {
			_showDiscussionModal();
			trackGroupSimpleAction(props.groupId, GroupAuditAction.VIEW_DISCUSSION_CREATE_PAGE);
		};
		watch(() => props.startDiscussion, (shouldDiscussionModalBeVisible) => {
			if (shouldDiscussionModalBeVisible && !isDiscussionModalVisible.value) {
				showDiscussionModal();
			} else if (!shouldDiscussionModalBeVisible && isDiscussionModalVisible.value) {
				closeDiscussionModal();
			}
		}, { immediate: true });
		// END Group Discussion Form Panel

		// Group join
		const {
			request: requestStateChange,
			isChangingState: isJoiningGroup,
		} = useGroupMemberStateChange();
		const showJoinLink = computed(() => {
			if (group.value) {
				return canSeeJoinLink(group.value);
			}
			return false;
		});
		const joinGroup = () => {
			requestStateChange(props.groupId, GroupRoleRequest.ACCEPT, (invalidInviteEmail.value ? props.email : undefined));

			// Here we are redirecting to the same URL, but without the Query Params.
			// This is to ensure that we don't attempt to reprocess the inviteId again later
			// by accident; for example if the user refreshes the page
			const { name, params, hash } = ctx.root.$route;
			ctx.root.$router.push({ name: name || undefined, params, hash });
		};
		// END Group join

		// Show limited access "Join" message
		// In some cases, there are no tabs visible (eg: a user has somehow accessed an auto-join group that did not auto-join them)
		const hasAnyTabs = computed(() => GROUP_TAB_BUTTONS.some((tab) => isTabEnabled(tab)));
		// END Show limited access "Join" message

		// Group visibility
		// Determines if the user is allowed to view content even if there is a group entry overlay
		// that gates their access to the group
		const canViewGroupContent = computed(() => isGroupContentVisible(group, hasGroupAccess(group.value, isCsr.value), isLoggedIn));
		// END Group visibility

		// Redirect to next tab if current tab is disabled in group
		const isCurrentGroupLoaded = computed(() => GroupsStore.getInstance().isGroupLoaded(props.groupId));
		watch([isCurrentGroupLoaded, currentTabKey], ([isLoaded]) => {
			if (!isLoaded || !canViewGroupContent.value || !hasAnyTabs.value) {
				return;
			}
			const requestedTab = currentTabKey.value;
			const isRequestedTabEnabled = isTabEnabled(requestedTab);
			if (!isRequestedTabEnabled && requestedTab !== null) {
				const nextRoute = FALLBACK_ROUTE[requestedTab];
				ctx.root.$router.push({ name: nextRoute });
			}
		}, { immediate: true });
		// END Redirect to next tab if current tab is disabled in group

		const routeToCreateEvent = computed(() => ({
			name: Routes.GROUP_ADMIN_EVENT_CREATE,
			params: { groupId: props.groupId },
		}));

		const { highlightButtonStyles } = useCommunityColors(computed(() => group.value?.community?.customColorPalette));

		return {
			// Community
			highlightButtonStyles,
			// Util
			Routes: {
				GROUP_ADMIN_DATA: Routes.GROUP_ADMIN_DATA,
			},
			ButtonPalettes,
			Size,
			group,
			groupIsLoading,
			groupHasError,
			showNavbar,
			// Joining
			isJoiningGroup,
			showJoinLink,
			joinGroup,
			// Tabbed nav
			currentTabKey,
			visibleTabs,
			// Group details
			areDetailsVisible,
			administrators,
			isTermsPanelVisible,
			isAdministeredGroup,
			// Pinned header
			sentinel,
			isHeaderPinned,
			// Members
			isLoadingMembers,
			// File Sharing view
			canShareFilesToGroup,
			canManageDocumentCategories,
			// Edit content panel
			selectedContent,
			closeEditContentModal,
			EDIT_CONTENT_PANEL_BY_TYPE,
			// Discussion form
			areDiscussionsEnabled,
			canStartDiscussions,
			canSeeStartDiscussionCta,
			isDiscussionModalVisible,
			discussionModalView,
			showDiscussionModal,
			closeDiscussionModal,
			// Event create
			routeToCreateEvent,
			// Invites
			currentUser,
			invalidInviteEmail,
			// Group visibility
			canViewGroupContent,
		};
	},
});
